<template>
  <div class="link-list">
    <a v-for="link in links" :key="link.id" :href="link.url" class="btn btn-link d-block" target="_blank" v-on:click="trackEvent(link.title)">{{link.title}}</a>
  </div>
</template>

<script>
import { page } from 'vue-analytics'

export default {
  data () {
    return {
      links: [
        {
          title: 'New Music Video: "Mango Dance"',
          url: 'https://youtu.be/k84xo2uGNHI'
        },
        {
          title: 'Get the track on BandCamp',
          url: 'https://flobaier.bandcamp.com/track/mango-dance'
        },
        {
          title: 'Music Video: "Bauwerk"',
          url: 'https://www.youtube.com/watch?v=dq4Pw-Gs83g'
        },
        {
          title: 'SoundCloud',
          url: 'https://soundcloud.com/hansfbaier'
        },
        {
          title: 'YouTube',
          url: 'https://www.youtube.com/channel/UCR4gGib-oRA70Zqsd6-dryQ'
        },
        {
          title: 'Instagram',
          url: 'https://www.instagram.com/hans_flo_baier/'
        }
      ]
    }
  },
  methods: {
    track () {
      page('/')
      this.$ga.screenview('home')
    },
    trackEvent (title) {
      this.$ga.event({
        eventCategory: 'linktracking',
        eventAction: title,
        eventLabel: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LinkList.vue